"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
const collection_list_style_1 = require("../collection.list/collection.list.style");
exports.CSS = {
    container: 'c-PMCollectionList',
    toolbar: {
        container: 'c-PMCollectionList__Toolbar'
    },
    collections: {
        container: 'c-PMCollectionList__Collections',
        content: 'c-PMCollectionList__Content',
        isEmpty: 'c-PMCollectionList__Collections--empty'
    },
    map: {
        container: 'c-PMCollectionList__Map',
        button: 'c-PMCollectionList__MapBtn'
    }
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'flex-direction': 'column',
        height: '100%',
        'background-color': theme_1.DefaultTheme.background.grey
    },
    [exports.CSS.toolbar.container]: {
        position: 'relative'
    },
    [exports.CSS.collections.container]: {
        flex: 1,
        'min-height': '100px',
        display: 'flex',
        'flex-direction': 'column'
    },
    [exports.CSS.collections.content]: {
        display: 'flex',
        flex: 1,
        'flex-direction': 'row',
        overflow: 'hidden',
        [`& .${collection_list_style_1.CSS.container}`]: {
            flex: 1,
            overflow: 'auto'
        }
    },
    [exports.CSS.collections.isEmpty]: {
        'flex-direction': 'row',
        'justify-content': 'center',
        'align-items': 'center'
    },
    [exports.CSS.map.container]: {
        flex: 0.77,
        border: `1px solid ${theme_1.DefaultTheme.font.color.divider}`
    },
    [exports.CSS.map.button]: {
        position: 'absolute',
        bottom: theme_1.DefaultTheme.space(8),
        left: theme_1.DefaultTheme.space(3),
        color: theme_1.DefaultTheme.font.color.primary,
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp6
    }
};
//# sourceMappingURL=photomeasure.collection.list.style.js.map